/**
 * Checks if passed color is in hex format (also support alpha).
 * The regex has OR condition because if specifying quantifier as {3,4},
 * then 7-digit codes would also match, which aren't valid hex.
 * @param {String} color
 * @return {Boolean}
 */
const isHexFormat = (color) => /^#([0-9A-F]{3}){1,2}$|^#([0-9A-F]{4}){1,2}$/i.test(color);

module.exports = isHexFormat;
